import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareK = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler11') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler11', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Bryophytas ess!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Bryophytas ess!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareK}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareK
  
